import { University } from "@/store/types/universityTypes";
import { BlueThreeStarts } from "../common/Icons";

const Strengths = ({ data }: { data: University }) => {
  return (
    <div className="pt-[32px] sm:pt-[40px] md:pt-[46px] lg:pt-[56px]">
      {/* <div className="bg-[#0E1116] flex flex-col sm:flex-row md:items-center gap-4 sm:gap-6 md:gap-8 lg:gap-10 xl:gap-[48px] rounded-[24px] py-[24px] px-4 sm:px-7 md:px-9 lg:px-[43px]">
        <div className="">
          <p className="ff_poppins text-sm sm:text-base text-white">
            QS Ranking
          </p>
          <p className="text-[32px] ff_poppins text-[#EB9757]">#27</p>
        </div>
        <div>
          <p className="text-base text-white ff_poppins">
            Why this ranking matters
          </p>
          <p className="mt-3 text-[#A7A7A7] text-sm ff_poppins">
            Top 30 globally - employer recognition in UK and India.
          </p>
        </div>
      </div> */}

      <p className="text-base font-semibold mt-6">KEY STRENGTHS</p>
      <div className="flex flex-col gap-3 mt-3">
        {data.metaData?.college_key_strengths?.map((strength, index) => (
          <div
            key={index}
            className="bg-white border border-[#D0C4FF] py-[10px] sm:py-3 px-3 sm:px-4 md:px-6 flex items-center gap-2 rounded-[12px]"
          >
            <span className="size-5 inline-block">
              <BlueThreeStarts colors="#EB9757" />
            </span>
            <p className="text-sm font-medium ff_poppins">{strength}</p>
          </div>
        ))}
        {/* <div className="bg-white border border-[#D0C4FF] py-[10px] sm:py-3 px-3 sm:px-4 md:px-6 flex items-center gap-2 rounded-[12px]">
          <span className="size-5 inline-block">
            <BlueThreeStarts colors="#EB9757" />
          </span>
          <p className="text-sm font-medium ff_poppins">
            94% graduate employment rate within 6 months
          </p>
        </div>
        <div className="bg-white border border-[#D0C4FF] py-[10px] sm:py-3 px-3 sm:px-4 md:px-6 flex items-center gap-2 rounded-[12px]">
          <span className="size-5 inline-block">
            <BlueThreeStarts colors="#EB9757" />
          </span>
          <p className="text-sm font-medium ff_poppins">
            Largest computer science school in the UK
          </p>
        </div> */}
      </div>
    </div>
  );
};
export default Strengths;
